// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AddContentFeedbackData,
  AddContentFeedbackErrors,
  AddContentFeedbackResponses,
  AddCourseData,
  AddCourseErrors,
  AddCourseResponses,
  AddData,
  AddErrors,
  AddResponses,
  AssignUsersToChecklist1Data,
  AssignUsersToChecklist1Errors,
  AssignUsersToChecklist1Responses,
  AssignUsersToChecklist2Data,
  AssignUsersToChecklist2Errors,
  AssignUsersToChecklist2Responses,
  AssignUsersToChecklist3Data,
  AssignUsersToChecklist3Errors,
  AssignUsersToChecklist3Responses,
  AssignUsersToChecklistData,
  AssignUsersToChecklistErrors,
  AssignUsersToChecklistResponses,
  ClearContentCacheData,
  ClearContentCacheErrors,
  ClearContentCacheResponses,
  CreateChecklistFromTemplateData,
  CreateChecklistFromTemplateErrors,
  CreateChecklistFromTemplateResponses,
  CreateCustomQuiz1Data,
  CreateCustomQuiz1Errors,
  CreateCustomQuiz1Responses,
  CreateCustomQuizData,
  CreateCustomQuizErrors,
  CreateCustomQuizResponses,
  CreateLocationPlansFromTemplatesData,
  CreateLocationPlansFromTemplatesErrors,
  CreateLocationPlansFromTemplatesResponses,
  CreateMarketTestData,
  CreateMarketTestErrors,
  CreateMarketTestResponses,
  DeleteCategoryByCountryCodeAndIdData,
  DeleteCategoryByCountryCodeAndIdErrors,
  DeleteCategoryByCountryCodeAndIdResponses,
  DeleteChecklist1Data,
  DeleteChecklist1Errors,
  DeleteChecklist1Responses,
  DeleteChecklist2Data,
  DeleteChecklist2Errors,
  DeleteChecklist2Responses,
  DeleteChecklistData,
  DeleteChecklistErrors,
  DeleteChecklistResponses,
  DeleteContentFeedbackData,
  DeleteContentFeedbackErrors,
  DeleteContentFeedbackResponses,
  DeleteCourseData,
  DeleteCourseErrors,
  DeleteCourseResponses,
  DeleteCustomQuiz1Data,
  DeleteCustomQuiz1Errors,
  DeleteCustomQuiz1Responses,
  DeleteCustomQuizData,
  DeleteCustomQuizErrors,
  DeleteCustomQuizResponses,
  DeleteData,
  DeleteDocumentData,
  DeleteDocumentErrors,
  DeleteDocumentResponses,
  DeleteErrors,
  DeleteMarketTestData,
  DeleteMarketTestErrors,
  DeleteMarketTestResponses,
  DeleteOperatorLikeData,
  DeleteOperatorLikeErrors,
  DeleteOperatorLikeResponses,
  DeleteResponses,
  DeleteSubcategoryData,
  DeleteSubcategoryErrors,
  DeleteSubcategoryResponses,
  DeleteSubtitleData,
  DeleteSubtitleErrors,
  DeleteSubtitleResponses,
  DuplicateChecklist1Data,
  DuplicateChecklist1Errors,
  DuplicateChecklist1Responses,
  DuplicateChecklist2Data,
  DuplicateChecklist2Errors,
  DuplicateChecklist2Responses,
  DuplicateChecklistData,
  DuplicateChecklistErrors,
  DuplicateChecklistResponses,
  DuplicateChecklistTemplate1Data,
  DuplicateChecklistTemplate1Errors,
  DuplicateChecklistTemplate1Responses,
  DuplicateChecklistTemplateData,
  DuplicateChecklistTemplateErrors,
  DuplicateChecklistTemplateResponses,
  GenerateCourseReportData,
  GenerateCourseReportErrors,
  GenerateCourseReportResponses,
  GetAllCoursesData,
  GetAllCoursesErrors,
  GetAllCoursesResponses,
  GetAllData,
  GetAllErrors,
  GetAllMarketTestsData,
  GetAllMarketTestsErrors,
  GetAllMarketTestsResponses,
  GetAllResponses,
  GetAscendOnDemandCoursesData,
  GetAscendOnDemandCoursesErrors,
  GetAscendOnDemandCoursesResponses,
  GetByIdData,
  GetByIdErrors,
  GetByIdResponses,
  GetCategoryByCountryCodeData,
  GetCategoryByCountryCodeErrors,
  GetCategoryByCountryCodeResponses,
  GetCategoryByIdData,
  GetCategoryByIdErrors,
  GetCategoryByIdResponses,
  GetCategoryIconsData,
  GetCategoryIconsErrors,
  GetCategoryIconsResponses,
  GetChecklist1Data,
  GetChecklist1Errors,
  GetChecklist1Responses,
  GetChecklist2Data,
  GetChecklist2Errors,
  GetChecklist2Responses,
  GetChecklistByUserIds1Data,
  GetChecklistByUserIds1Errors,
  GetChecklistByUserIds1Responses,
  GetChecklistByUserIdsData,
  GetChecklistByUserIdsErrors,
  GetChecklistByUserIdsResponses,
  GetChecklistData,
  GetChecklistErrors,
  GetChecklistResponses,
  GetComplianceCoursesData,
  GetComplianceCoursesErrors,
  GetComplianceCoursesResponses,
  GetCourseByIdData,
  GetCourseByIdErrors,
  GetCourseByIdResponses,
  GetCurrentUserLocationsData,
  GetCurrentUserLocationsErrors,
  GetCurrentUserLocationsResponses,
  GetCustomQuizDetails1Data,
  GetCustomQuizDetails1Errors,
  GetCustomQuizDetails1Responses,
  GetCustomQuizDetailsData,
  GetCustomQuizDetailsErrors,
  GetCustomQuizDetailsResponses,
  GetCustomQuizzes1Data,
  GetCustomQuizzes1Errors,
  GetCustomQuizzes1Responses,
  GetCustomQuizzesData,
  GetCustomQuizzesErrors,
  GetCustomQuizzesResponses,
  GetDocumentData,
  GetDocumentErrors,
  GetDocumentResponses,
  GetFilteredPlans1Data,
  GetFilteredPlans1Errors,
  GetFilteredPlans1Responses,
  GetFilteredPlansData,
  GetFilteredPlansErrors,
  GetFilteredPlansResponses,
  GetJobStatusData,
  GetJobStatusErrors,
  GetJobStatusResponses,
  GetLeadershipCoursesData,
  GetLeadershipCoursesErrors,
  GetLeadershipCoursesResponses,
  GetLocationsByConceptTypeData,
  GetLocationsByConceptTypeErrors,
  GetLocationsByConceptTypeResponses,
  GetMarketTestByIdData,
  GetMarketTestByIdErrors,
  GetMarketTestByIdResponses,
  GetMarketTestDocumentsData,
  GetMarketTestDocumentsErrors,
  GetMarketTestDocumentsResponses,
  GetMarketTestsByLocationData,
  GetMarketTestsByLocationErrors,
  GetMarketTestsByLocationResponses,
  GetMyMarketTestsData,
  GetMyMarketTestsErrors,
  GetMyMarketTestsResponses,
  GetOperatorCourseSettingsData,
  GetOperatorCourseSettingsErrors,
  GetOperatorCourseSettingsResponses,
  GetProcedureIconsData,
  GetProcedureIconsErrors,
  GetProcedureIconsResponses,
  GetSqsslData,
  GetSqsslErrors,
  GetSqsslResponses,
  GetSubcategoryData,
  GetSubcategoryErrors,
  GetSubcategoryResponses,
  GetSubtitleData,
  GetSubtitleErrors,
  GetSubtitleResponses,
  GetTeamMembersStatusReport1Data,
  GetTeamMembersStatusReport1Errors,
  GetTeamMembersStatusReport1Responses,
  GetTeamMembersStatusReportData,
  GetTeamMembersStatusReportErrors,
  GetTeamMembersStatusReportResponses,
  GetTemplatesData,
  GetTemplatesErrors,
  GetTemplatesResponses,
  GetVideoContentData,
  GetVideoContentErrors,
  GetVideoContentResponses,
  LearnUponWebhookData,
  LearnUponWebhookErrors,
  LearnUponWebhookResponses,
  LearnUponWebhookV2Data,
  LearnUponWebhookV2Errors,
  LearnUponWebhookV2Responses,
  ListAllChecklistsData,
  ListAllChecklistsErrors,
  ListAllChecklistsResponses,
  ListAssignableChecklists1Data,
  ListAssignableChecklists1Errors,
  ListAssignableChecklists1Responses,
  ListAssignableChecklists2Data,
  ListAssignableChecklists2Errors,
  ListAssignableChecklists2Responses,
  ListAssignableChecklistsData,
  ListAssignableChecklistsErrors,
  ListAssignableChecklistsResponses,
  ListAssignedByChecklist1Data,
  ListAssignedByChecklist1Errors,
  ListAssignedByChecklist1Responses,
  ListAssignedByChecklist2Data,
  ListAssignedByChecklist2Errors,
  ListAssignedByChecklist2Responses,
  ListAssignedByChecklistData,
  ListAssignedByChecklistErrors,
  ListAssignedByChecklistResponses,
  ListAssignedChecklists1Data,
  ListAssignedChecklists1Errors,
  ListAssignedChecklists1Responses,
  ListAssignedChecklistsData,
  ListAssignedChecklistsErrors,
  ListAssignedChecklistsResponses,
  ListChecklists1Data,
  ListChecklists1Errors,
  ListChecklists1Responses,
  ListChecklistsData,
  ListChecklistsErrors,
  ListChecklistsResponses,
  ListChecklistTemplates1Data,
  ListChecklistTemplates1Errors,
  ListChecklistTemplates1Responses,
  ListChecklistTemplatesData,
  ListChecklistTemplatesErrors,
  ListChecklistTemplatesResponses,
  ListEditableChecklists1Data,
  ListEditableChecklists1Errors,
  ListEditableChecklists1Responses,
  ListEditableChecklists2Data,
  ListEditableChecklists2Errors,
  ListEditableChecklists2Responses,
  ListEditableChecklistsData,
  ListEditableChecklistsErrors,
  ListEditableChecklistsResponses,
  ListEnrollmentsByCourseData,
  ListEnrollmentsByCourseErrors,
  ListEnrollmentsByCourseResponses,
  ListMyChecklists1Data,
  ListMyChecklists1Errors,
  ListMyChecklists1Responses,
  ListMyChecklistsData,
  ListMyChecklistsErrors,
  ListMyChecklistsResponses,
  ListOperatorsData,
  ListOperatorsErrors,
  ListOperatorsResponses,
  ListRelatedDocumentsData,
  ListRelatedDocumentsErrors,
  ListRelatedDocumentsResponses,
  ListSubcategoriesData,
  ListSubcategoriesErrors,
  ListSubcategoriesResponses,
  ListSubtitlesData,
  ListSubtitlesErrors,
  ListSubtitlesResponses,
  ListUsersData,
  ListUsersErrors,
  ListUsersResponses,
  MigrateFolderData,
  MigrateFolderErrors,
  MigrateFolderResponses,
  NewIndexDocument1Data,
  NewIndexDocument1Errors,
  NewIndexDocument1Responses,
  NewIndexDocumentData,
  NewIndexDocumentErrors,
  NewIndexDocumentResponses,
  RefreshFoodSafetyLettersCacheData,
  RefreshFoodSafetyLettersCacheErrors,
  RefreshFoodSafetyLettersCacheResponses,
  ReportPlansData,
  ReportPlansErrors,
  ReportPlansResponses,
  ReportTeamMemberData,
  ReportTeamMemberErrors,
  ReportTeamMemberResponses,
  ReportTeamMembersData,
  ReportTeamMembersErrors,
  ReportTeamMembersResponses,
  ReportUsersProgressData,
  ReportUsersProgressErrors,
  ReportUsersProgressResponses,
  ResetAllChecklistStepsState1Data,
  ResetAllChecklistStepsState1Errors,
  ResetAllChecklistStepsState1Responses,
  ResetAllChecklistStepsState2Data,
  ResetAllChecklistStepsState2Errors,
  ResetAllChecklistStepsState2Responses,
  ResetAllChecklistStepsStateData,
  ResetAllChecklistStepsStateErrors,
  ResetAllChecklistStepsStateResponses,
  RetrieveUserPreferencesData,
  RetrieveUserPreferencesErrors,
  RetrieveUserPreferencesResponses,
  SaveCategoriesData,
  SaveCategoriesErrors,
  SaveCategoriesResponses,
  SaveCategoryData,
  SaveCategoryErrors,
  SaveCategoryResponses,
  SaveChecklist1Data,
  SaveChecklist1Errors,
  SaveChecklist1Responses,
  SaveChecklist2Data,
  SaveChecklist2Errors,
  SaveChecklist2Responses,
  SaveChecklistData,
  SaveChecklistErrors,
  SaveChecklistResponses,
  SaveDocumentsData,
  SaveDocumentsErrors,
  SaveDocumentsResponses,
  SaveSubcategoriesData,
  SaveSubcategoriesErrors,
  SaveSubcategoriesResponses,
  SaveSubtitlesData,
  SaveSubtitlesErrors,
  SaveSubtitlesResponses,
  SaveUserPreferencesData,
  SaveUserPreferencesErrors,
  SaveUserPreferencesResponses,
  SetAuthCookieData,
  SetAuthCookieErrors,
  SetAuthCookieResponses,
  SetDueDateOnChecklist1Data,
  SetDueDateOnChecklist1Errors,
  SetDueDateOnChecklist1Responses,
  SetDueDateOnChecklist2Data,
  SetDueDateOnChecklist2Errors,
  SetDueDateOnChecklist2Responses,
  SetDueDateOnChecklistData,
  SetDueDateOnChecklistErrors,
  SetDueDateOnChecklistResponses,
  SetMarketTestProceduresData,
  SetMarketTestProceduresErrors,
  SetMarketTestProceduresResponses,
  SetOperatorCourseSettingData,
  SetOperatorCourseSettingErrors,
  SetOperatorCourseSettingResponses,
  SetOperatorLikeData,
  SetOperatorLikeErrors,
  SetOperatorLikeResponses,
  StepHeartbeatData,
  StepHeartbeatErrors,
  StepHeartbeatResponses,
  SynchronizeUserData,
  SynchronizeUserErrors,
  SynchronizeUserResponses,
  TranslateData,
  TranslateErrors,
  TranslateResponses,
  TypeformQuizData,
  TypeformQuizErrors,
  TypeformQuizResponses,
  UnassignUsersToChecklist1Data,
  UnassignUsersToChecklist1Errors,
  UnassignUsersToChecklist1Responses,
  UnassignUsersToChecklist2Data,
  UnassignUsersToChecklist2Errors,
  UnassignUsersToChecklist2Responses,
  UnassignUsersToChecklistData,
  UnassignUsersToChecklistErrors,
  UnassignUsersToChecklistResponses,
  UpdateChecklist1Data,
  UpdateChecklist1Errors,
  UpdateChecklist1Responses,
  UpdateChecklist2Data,
  UpdateChecklist2Errors,
  UpdateChecklist2Responses,
  UpdateChecklistData,
  UpdateChecklistErrors,
  UpdateChecklistResponses,
  UpdateChecklistStatus1Data,
  UpdateChecklistStatus1Errors,
  UpdateChecklistStatus1Responses,
  UpdateChecklistStatus2Data,
  UpdateChecklistStatus2Errors,
  UpdateChecklistStatus2Responses,
  UpdateChecklistStatusData,
  UpdateChecklistStatusErrors,
  UpdateChecklistStatusResponses,
  UpdateChecklistStepStatus1Data,
  UpdateChecklistStepStatus1Errors,
  UpdateChecklistStepStatus1Responses,
  UpdateChecklistStepStatusData,
  UpdateChecklistStepStatusErrors,
  UpdateChecklistStepStatusResponses,
  UpdateCourseData,
  UpdateCourseErrors,
  UpdateCourseResponses,
  UpdateCustomQuiz1Data,
  UpdateCustomQuiz1Errors,
  UpdateCustomQuiz1Responses,
  UpdateCustomQuizData,
  UpdateCustomQuizErrors,
  UpdateCustomQuizResponses,
  UpdateData,
  UpdateErrors,
  UpdateMarketTestData,
  UpdateMarketTestErrors,
  UpdateMarketTestResponses,
  UpdateResponses,
  UpdateStepStatusData,
  UpdateStepStatusErrors,
  UpdateStepStatusResponses,
  UpdateUserComplianceCourseDurationData,
  UpdateUserComplianceCourseDurationErrors,
  UpdateUserComplianceCourseDurationResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get raw content by documentGuid
 */
export const getVideoContent = <ThrowOnError extends boolean = false>(
  options?: Options<GetVideoContentData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVideoContentResponses,
    GetVideoContentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/brightcove',
    ...options,
  });
};

/**
 * Clear the content cache
 */
export const clearContentCache = <ThrowOnError extends boolean = false>(
  options?: Options<ClearContentCacheData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ClearContentCacheResponses,
    ClearContentCacheErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/cache/clear',
    ...options,
  });
};

/**
 * Refresh food safety letters cache (requires scope: pathway-content:maintenance)
 */
export const refreshFoodSafetyLettersCache = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RefreshFoodSafetyLettersCacheData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RefreshFoodSafetyLettersCacheResponses,
    RefreshFoodSafetyLettersCacheErrors,
    ThrowOnError
  >({
    url: '/cache/food-safety-letters/refresh',
    ...options,
  });
};

/**
 * Get Categories by Country Code
 */
export const getCategoryByCountryCode = <ThrowOnError extends boolean = false>(
  options?: Options<GetCategoryByCountryCodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCategoryByCountryCodeResponses,
    GetCategoryByCountryCodeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/categories',
    ...options,
  });
};

/**
 * Add or update Categories List
 */
export const saveCategories = <ThrowOnError extends boolean = false>(
  options: Options<SaveCategoriesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveCategoriesResponses,
    SaveCategoriesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Add or update single category
 */
export const saveCategory = <ThrowOnError extends boolean = false>(
  options: Options<SaveCategoryData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    SaveCategoryResponses,
    SaveCategoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete category by Country and ID
 */
export const deleteCategoryByCountryCodeAndId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteCategoryByCountryCodeAndIdData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteCategoryByCountryCodeAndIdResponses,
    DeleteCategoryByCountryCodeAndIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/categories/{country}/{id}',
    ...options,
  });
};

/**
 * Get Category by Id
 */
export const getCategoryById = <ThrowOnError extends boolean = false>(
  options: Options<GetCategoryByIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCategoryByIdResponses,
    GetCategoryByIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/categories/{id}',
    ...options,
  });
};

/**
 * Create a checklist
 * @deprecated
 */
export const saveChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<SaveChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveChecklist2Responses,
    SaveChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update a checklist
 * @deprecated
 */
export const updateChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateChecklist2Responses,
    UpdateChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all training checklists
 * @deprecated
 */
export const listChecklists1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListChecklists1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListChecklists1Responses,
    ListChecklists1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/all',
    ...options,
  });
};

/**
 * List all training checklists the active user can assign users to, as well as their assigned counts
 * @deprecated
 */
export const listAssignableChecklists2 = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignableChecklists2Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAssignableChecklists2Responses,
    ListAssignableChecklists2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/assignable',
    ...options,
  });
};

/**
 * List assigned training checklists
 * @deprecated
 */
export const listAssignedChecklists1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignedChecklists1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAssignedChecklists1Responses,
    ListAssignedChecklists1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/assigned',
    ...options,
  });
};

/**
 * Status of all assigned users to this training checklist
 * @deprecated
 */
export const listAssignedByChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<ListAssignedByChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListAssignedByChecklist2Responses,
    ListAssignedByChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/assigned/{checklist}',
    ...options,
  });
};

/**
 * Get checklist status report for team members
 * @deprecated
 */
export const getTeamMembersStatusReport1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTeamMembersStatusReport1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamMembersStatusReport1Responses,
    GetTeamMembersStatusReport1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/checklists/statusreport',
    ...options,
  });
};

/**
 * List all training checklists the active user can edit/modify
 * @deprecated
 */
export const listEditableChecklists2 = <ThrowOnError extends boolean = false>(
  options?: Options<ListEditableChecklists2Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEditableChecklists2Responses,
    ListEditableChecklists2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/editable',
    ...options,
  });
};

/**
 * List assigned training checklists
 * @deprecated
 */
export const listMyChecklists1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyChecklists1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMyChecklists1Responses,
    ListMyChecklists1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/my',
    ...options,
  });
};

/**
 * Reset current state of Checklist for a user
 * @deprecated
 */
export const resetAllChecklistStepsState2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResetAllChecklistStepsState2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ResetAllChecklistStepsState2Responses,
    ResetAllChecklistStepsState2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all training checklist templates
 * @deprecated
 */
export const listChecklistTemplates1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListChecklistTemplates1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListChecklistTemplates1Responses,
    ListChecklistTemplates1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/templates',
    ...options,
  });
};

/**
 * Duplicate a checklist template
 * @deprecated
 */
export const duplicateChecklistTemplate1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DuplicateChecklistTemplate1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DuplicateChecklistTemplate1Responses,
    DuplicateChecklistTemplate1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/templates/{duplicatedId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Unassign one or more Team members to a Checklist
 * @deprecated
 */
export const unassignUsersToChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<UnassignUsersToChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    UnassignUsersToChecklist2Responses,
    UnassignUsersToChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign one or more Team members to a Checklist
 * @deprecated
 */
export const assignUsersToChecklist3 = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToChecklist3Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssignUsersToChecklist3Responses,
    AssignUsersToChecklist3Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 * @deprecated
 */
export const setDueDateOnChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<SetDueDateOnChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetDueDateOnChecklist2Responses,
    SetDueDateOnChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistId}/dueDate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set checklist status by ID
 * @deprecated
 */
export const updateChecklistStatus2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklistStatus2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateChecklistStatus2Responses,
    UpdateChecklistStatus2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistId}/{status}',
    ...options,
  });
};

/**
 * Set checklist step status by ID
 * @deprecated
 */
export const updateChecklistStepStatus1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateChecklistStepStatus1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateChecklistStepStatus1Responses,
    UpdateChecklistStepStatus1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistId}/{stepId}/{status}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Checklist by Checklist ID and User IDs
 * @deprecated
 */
export const getChecklistByUserIds1 = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklistByUserIds1Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetChecklistByUserIds1Responses,
    GetChecklistByUserIds1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{checklistid}/status',
    ...options,
  });
};

/**
 * Delete checklist by ID
 * @deprecated
 */
export const deleteChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteChecklist2Responses,
    DeleteChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{id}',
    ...options,
  });
};

/**
 * Get checklist by ID
 * @deprecated
 */
export const getChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetChecklist2Responses,
    GetChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{id}',
    ...options,
  });
};

/**
 * Duplicate a checklist
 * @deprecated
 */
export const duplicateChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DuplicateChecklist2Responses,
    DuplicateChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/checklist/{sourceChecklistId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List All Courses
 */
export const getAllCourses = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllCoursesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAllCoursesResponses,
    GetAllCoursesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses',
    ...options,
  });
};

/**
 * Add a Course
 */
export const addCourse = <ThrowOnError extends boolean = false>(
  options: Options<AddCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AddCourseResponses,
    AddCourseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklist2 = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToChecklist2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssignUsersToChecklist2Responses,
    AssignUsersToChecklist2Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/assign/{courseId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Status of all current enrollments to this course by optional location
 */
export const listEnrollmentsByCourse = <ThrowOnError extends boolean = false>(
  options: Options<ListEnrollmentsByCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListEnrollmentsByCourseResponses,
    ListEnrollmentsByCourseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/assigned/{courseId}',
    ...options,
  });
};

/**
 * Gets compliance courses based on country selected in user's profile
 */
export const getComplianceCourses = <ThrowOnError extends boolean = false>(
  options?: Options<GetComplianceCoursesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetComplianceCoursesResponses,
    GetComplianceCoursesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/compliance',
    ...options,
  });
};

/**
 * Sensitive data report on course by location
 */
export const generateCourseReport = <ThrowOnError extends boolean = false>(
  options: Options<GenerateCourseReportData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GenerateCourseReportResponses,
    GenerateCourseReportErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/report/{courseId}',
    ...options,
  });
};

/**
 * Returns course settings for an operator
 */
export const getOperatorCourseSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetOperatorCourseSettingsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetOperatorCourseSettingsResponses,
    GetOperatorCourseSettingsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/settings',
    ...options,
  });
};

/**
 * Enables or Disables a course for an operator
 */
export const setOperatorCourseSetting = <ThrowOnError extends boolean = false>(
  options: Options<SetOperatorCourseSettingData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetOperatorCourseSettingResponses,
    SetOperatorCourseSettingErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/settings/{courseId}/{enable}',
    ...options,
  });
};

/**
 * Get SQSSO
 */
export const getSqssl = <ThrowOnError extends boolean = false>(
  options: Options<GetSqsslData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetSqsslResponses,
    GetSqsslErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/sqsso/{courseId}',
    ...options,
  });
};

/**
 * Synchronize User with LearnUpon
 */
export const synchronizeUser = <ThrowOnError extends boolean = false>(
  options: Options<SynchronizeUserData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SynchronizeUserResponses,
    SynchronizeUserErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/sync/{userId}',
    ...options,
  });
};

/**
 * Handle LearnUpon webhook event
 */
export const learnUponWebhook = <ThrowOnError extends boolean = false>(
  options: Options<LearnUponWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    LearnUponWebhookResponses,
    LearnUponWebhookErrors,
    ThrowOnError
  >({
    url: '/courses/webhook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Course by ID
 */
export const deleteCourse = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteCourseResponses,
    DeleteCourseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/{id}',
    ...options,
  });
};

/**
 * Get Course by ID
 */
export const getCourseById = <ThrowOnError extends boolean = false>(
  options: Options<GetCourseByIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCourseByIdResponses,
    GetCourseByIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/{id}',
    ...options,
  });
};

/**
 * Update a course
 */
export const updateCourse = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCourseData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateCourseResponses,
    UpdateCourseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set course status by ID
 */
export const updateUserComplianceCourseDuration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserComplianceCourseDurationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateUserComplianceCourseDurationResponses,
    UpdateUserComplianceCourseDurationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/courses/{pathwayCourseId}/heartbeat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Start the Pathway Crawler to pull in and index third party content
 */
export const newIndexDocument1 = <ThrowOnError extends boolean = false>(
  options?: Options<NewIndexDocument1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    NewIndexDocument1Responses,
    NewIndexDocument1Errors,
    ThrowOnError
  >({
    url: '/crawl/index',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get the status of an index job
 */
export const getJobStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetJobStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetJobStatusResponses,
    GetJobStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/crawl/job/{id}',
    ...options,
  });
};

/**
 * Start the Pathway Crawler to pull in and index third party content
 */
export const newIndexDocument = <ThrowOnError extends boolean = false>(
  options?: Options<NewIndexDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    NewIndexDocumentResponses,
    NewIndexDocumentErrors,
    ThrowOnError
  >({
    url: '/crawl/newindex',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Add or update documents
 */
export const saveDocuments = <ThrowOnError extends boolean = false>(
  options: Options<SaveDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveDocumentsResponses,
    SaveDocumentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sets auth cookie in response header
 */
export const setAuthCookie = <ThrowOnError extends boolean = false>(
  options?: Options<SetAuthCookieData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SetAuthCookieResponses,
    SetAuthCookieErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/documents/cookie',
    ...options,
  });
};

/**
 * Migrate Xyleme document folder from external environment
 */
export const migrateFolder = <ThrowOnError extends boolean = false>(
  options: Options<MigrateFolderData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    MigrateFolderResponses,
    MigrateFolderErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/documents/migrate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete document by ID
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteDocumentResponses,
    DeleteDocumentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/documents/{id}',
    ...options,
  });
};

/**
 * Get document by ID
 */
export const getDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetDocumentResponses,
    GetDocumentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/documents/{id}',
    ...options,
  });
};

/**
 * Add Content Feedback record
 */
export const addContentFeedback = <ThrowOnError extends boolean = false>(
  options: Options<AddContentFeedbackData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AddContentFeedbackResponses,
    AddContentFeedbackErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/feedback/{contentType}/{contentId}',
    ...options,
  });
};

/**
 * Delete content feedback by id.
 */
export const deleteContentFeedback = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContentFeedbackData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteContentFeedbackResponses,
    DeleteContentFeedbackErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/feedback/{id}',
    ...options,
  });
};

/**
 * Get Training Checklists based upon Request
 */
export const getFilteredPlans1 = <ThrowOnError extends boolean = false>(
  options: Options<GetFilteredPlans1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GetFilteredPlans1Responses,
    GetFilteredPlans1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/filteredPlans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List All Games
 */
export const getAll = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAllResponses,
    GetAllErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/games',
    ...options,
  });
};

/**
 * Add a Course
 */
export const add = <ThrowOnError extends boolean = false>(
  options: Options<AddData, ThrowOnError>,
) => {
  return (options.client ?? client).post<AddResponses, AddErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/games',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  );
};

/**
 * Delete Course by ID
 */
export const delete_ = <ThrowOnError extends boolean = false>(
  options: Options<DeleteData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteResponses,
    DeleteErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/games/{id}',
    ...options,
  });
};

/**
 * Get Course by ID
 */
export const getById = <ThrowOnError extends boolean = false>(
  options: Options<GetByIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetByIdResponses,
    GetByIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/games/{id}',
    ...options,
  });
};

/**
 * Update a course
 */
export const update = <ThrowOnError extends boolean = false>(
  options: Options<UpdateData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateResponses,
    UpdateErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/games/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get a list of all category icons
 */
export const getCategoryIcons = <ThrowOnError extends boolean = false>(
  options?: Options<GetCategoryIconsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCategoryIconsResponses,
    GetCategoryIconsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/icons/categories',
    ...options,
  });
};

/**
 * Get a list of all procedure icons
 */
export const getProcedureIcons = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcedureIconsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProcedureIconsResponses,
    GetProcedureIconsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/icons/procedures',
    ...options,
  });
};

/**
 * List All Seasons
 */
export const getLeadershipCourses = <ThrowOnError extends boolean = false>(
  options?: Options<GetLeadershipCoursesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetLeadershipCoursesResponses,
    GetLeadershipCoursesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/leadershiptraining',
    ...options,
  });
};

/**
 * List Ascend On Demand Courses
 */
export const getAscendOnDemandCourses = <ThrowOnError extends boolean = false>(
  options: Options<GetAscendOnDemandCoursesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetAscendOnDemandCoursesResponses,
    GetAscendOnDemandCoursesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/leadershiptraining/aodcourses/{countryCode}',
    ...options,
  });
};

/**
 * Delete Operator 'Like' on an Episode
 */
export const deleteOperatorLike = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOperatorLikeData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteOperatorLikeResponses,
    DeleteOperatorLikeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/leadershiptraining/like/{pathwayCourseId}',
    ...options,
  });
};

/**
 * Set Operator 'Like' on an Episode
 */
export const setOperatorLike = <ThrowOnError extends boolean = false>(
  options: Options<SetOperatorLikeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetOperatorLikeResponses,
    SetOperatorLikeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/leadershiptraining/like/{pathwayCourseId}',
    ...options,
  });
};

export const createLocationPlansFromTemplates = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateLocationPlansFromTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateLocationPlansFromTemplatesResponses,
    CreateLocationPlansFromTemplatesErrors,
    ThrowOnError
  >({
    url: '/location-plans-from-templates',
    ...options,
  });
};

/**
 * Get locations by concept type
 */
export const getLocationsByConceptType = <ThrowOnError extends boolean = false>(
  options: Options<GetLocationsByConceptTypeData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLocationsByConceptTypeResponses,
    GetLocationsByConceptTypeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/locations',
    ...options,
  });
};

/**
 * Get current users locations
 */
export const getCurrentUserLocations = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserLocationsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCurrentUserLocationsResponses,
    GetCurrentUserLocationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/locations/me',
    ...options,
  });
};

/**
 * List Market Tests
 */
export const getAllMarketTests = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllMarketTestsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAllMarketTestsResponses,
    GetAllMarketTestsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest',
    ...options,
  });
};

/**
 * Add Market Tests (Including assigning locations)
 */
export const createMarketTest = <ThrowOnError extends boolean = false>(
  options: Options<CreateMarketTestData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateMarketTestResponses,
    CreateMarketTestErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Market Tests Assigned to Locations
 */
export const getMarketTestsByLocation = <ThrowOnError extends boolean = false>(
  options: Options<GetMarketTestsByLocationData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMarketTestsByLocationResponses,
    GetMarketTestsByLocationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/location/{locationIds}',
    ...options,
  });
};

/**
 * List Market Tests available to User
 */
export const getMyMarketTests = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyMarketTestsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMyMarketTestsResponses,
    GetMyMarketTestsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/my',
    ...options,
  });
};

/**
 * Delete market test by ID
 */
export const deleteMarketTest = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMarketTestData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteMarketTestResponses,
    DeleteMarketTestErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/{id}',
    ...options,
  });
};

/**
 * Get Market Test by ID
 */
export const getMarketTestById = <ThrowOnError extends boolean = false>(
  options: Options<GetMarketTestByIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMarketTestByIdResponses,
    GetMarketTestByIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/{id}',
    ...options,
  });
};

/**
 * Update a Market Test (Including assigning locations)
 */
export const updateMarketTest = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMarketTestData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateMarketTestResponses,
    UpdateMarketTestErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Procedures by Market Test ID
 */
export const getMarketTestDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetMarketTestDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetMarketTestDocumentsResponses,
    GetMarketTestDocumentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/{marketTestId}/documents',
    ...options,
  });
};

/**
 * Update Procedures within a Market Test
 */
export const setMarketTestProcedures = <ThrowOnError extends boolean = false>(
  options: Options<SetMarketTestProceduresData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    SetMarketTestProceduresResponses,
    SetMarketTestProceduresErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/markettest/{marketTestId}/procedures',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets a list of custom quizzes
 */
export const getCustomQuizzes1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomQuizzes1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCustomQuizzes1Responses,
    GetCustomQuizzes1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/quiz',
    ...options,
  });
};

/**
 * Create a custom quiz
 */
export const createCustomQuiz1 = <ThrowOnError extends boolean = false>(
  options: Options<CreateCustomQuiz1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateCustomQuiz1Responses,
    CreateCustomQuiz1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/quiz',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuiz1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCustomQuiz1Data, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateCustomQuiz1Responses,
    UpdateCustomQuiz1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/quiz',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuiz1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCustomQuiz1Data, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteCustomQuiz1Responses,
    DeleteCustomQuiz1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/quiz/{customQuizId}',
    ...options,
  });
};

/**
 * Get custom quiz details
 */
export const getCustomQuizDetails1 = <ThrowOnError extends boolean = false>(
  options: Options<GetCustomQuizDetails1Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCustomQuizDetails1Responses,
    GetCustomQuizDetails1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/quiz/{customQuizId}',
    ...options,
  });
};

/**
 * query Xyleme for related documents
 */
export const listRelatedDocuments = <ThrowOnError extends boolean = false>(
  options: Options<ListRelatedDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListRelatedDocumentsResponses,
    ListRelatedDocumentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/related/{id}',
    ...options,
  });
};

/**
 * Get assignable plans with assignment totals
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportPlans = <ThrowOnError extends boolean = false>(
  options?: Options<ReportPlansData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ReportPlansResponses,
    ReportPlansErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/reports/training/plans',
    ...options,
  });
};

/**
 * Get user's training plans by userId
 */
export const reportTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<ReportTeamMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ReportTeamMemberResponses,
    ReportTeamMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/reports/training/teamMember/{adId}',
    ...options,
  });
};

/**
 * Get team members plan assignment totals
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportTeamMembers = <ThrowOnError extends boolean = false>(
  options?: Options<ReportTeamMembersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ReportTeamMembersResponses,
    ReportTeamMembersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/reports/training/teamMembers',
    ...options,
  });
};

/**
 * Get users progress for a specific plan
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportUsersProgress = <ThrowOnError extends boolean = false>(
  options: Options<ReportUsersProgressData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ReportUsersProgressResponses,
    ReportUsersProgressErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/reports/training/teamMembers/plans/{planId}',
    ...options,
  });
};

/**
 * Translate
 */
export const translate = <ThrowOnError extends boolean = false>(
  options: Options<TranslateData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    TranslateResponses,
    TranslateErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/service/translate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List subcategories
 * @deprecated
 */
export const listSubcategories = <ThrowOnError extends boolean = false>(
  options?: Options<ListSubcategoriesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSubcategoriesResponses,
    ListSubcategoriesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subcategories',
    ...options,
  });
};

/**
 * Add or update subcategories
 * @deprecated
 */
export const saveSubcategories = <ThrowOnError extends boolean = false>(
  options: Options<SaveSubcategoriesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveSubcategoriesResponses,
    SaveSubcategoriesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subcategories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete subcategory by ID
 * @deprecated
 */
export const deleteSubcategory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSubcategoryData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteSubcategoryResponses,
    DeleteSubcategoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subcategories/{id}',
    ...options,
  });
};

/**
 * Get category by ID
 * @deprecated
 */
export const getSubcategory = <ThrowOnError extends boolean = false>(
  options: Options<GetSubcategoryData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetSubcategoryResponses,
    GetSubcategoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subcategories/{id}',
    ...options,
  });
};

/**
 * List subtitles
 * @deprecated
 */
export const listSubtitles = <ThrowOnError extends boolean = false>(
  options?: Options<ListSubtitlesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSubtitlesResponses,
    ListSubtitlesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subtitles',
    ...options,
  });
};

/**
 * Add or update subtitle
 * @deprecated
 */
export const saveSubtitles = <ThrowOnError extends boolean = false>(
  options: Options<SaveSubtitlesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveSubtitlesResponses,
    SaveSubtitlesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subtitles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete subtitle by ID
 * @deprecated
 */
export const deleteSubtitle = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSubtitleData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteSubtitleResponses,
    DeleteSubtitleErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subtitles/{id}',
    ...options,
  });
};

/**
 * Get subtitle by ID
 * @deprecated
 */
export const getSubtitle = <ThrowOnError extends boolean = false>(
  options: Options<GetSubtitleData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetSubtitleResponses,
    GetSubtitleErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/subtitles/{id}',
    ...options,
  });
};

/**
 * Create a checklist
 */
export const saveChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<SaveChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveChecklist1Responses,
    SaveChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update a checklist
 */
export const updateChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateChecklist1Responses,
    UpdateChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all training checklists
 */
export const listChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListChecklistsResponses,
    ListChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/all',
    ...options,
  });
};

/**
 * List all training checklists the active user can assign users to, as well as their assigned counts
 */
export const listAssignableChecklists1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignableChecklists1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAssignableChecklists1Responses,
    ListAssignableChecklists1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/assignable',
    ...options,
  });
};

/**
 * List assigned training checklists
 */
export const listAssignedChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignedChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAssignedChecklistsResponses,
    ListAssignedChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/assigned',
    ...options,
  });
};

/**
 * Status of all assigned users to this training checklist
 */
export const listAssignedByChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<ListAssignedByChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListAssignedByChecklist1Responses,
    ListAssignedByChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/assigned/{checklist}',
    ...options,
  });
};

/**
 * List all training checklists the active user can edit/modify
 */
export const listEditableChecklists1 = <ThrowOnError extends boolean = false>(
  options?: Options<ListEditableChecklists1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEditableChecklists1Responses,
    ListEditableChecklists1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/editable',
    ...options,
  });
};

/**
 * List assigned training checklists
 */
export const listMyChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMyChecklistsResponses,
    ListMyChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/my',
    ...options,
  });
};

/**
 * Reset current state of Checklist for a user
 */
export const resetAllChecklistStepsState1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResetAllChecklistStepsState1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ResetAllChecklistStepsState1Responses,
    ResetAllChecklistStepsState1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all training checklist templates
 */
export const listChecklistTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<ListChecklistTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListChecklistTemplatesResponses,
    ListChecklistTemplatesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/templates',
    ...options,
  });
};

/**
 * Update a checklist template
 */
export const duplicateChecklistTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DuplicateChecklistTemplateData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DuplicateChecklistTemplateResponses,
    DuplicateChecklistTemplateErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/templates/{duplicatedId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Unassign one or more Team members to a Checklist
 */
export const unassignUsersToChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<UnassignUsersToChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    UnassignUsersToChecklist1Responses,
    UnassignUsersToChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssignUsersToChecklist1Responses,
    AssignUsersToChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 */
export const setDueDateOnChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<SetDueDateOnChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetDueDateOnChecklist1Responses,
    SetDueDateOnChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistId}/dueDate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set checklist status by ID
 */
export const updateChecklistStatus1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklistStatus1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateChecklistStatus1Responses,
    UpdateChecklistStatus1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistId}/{status}',
    ...options,
  });
};

/**
 * Set checklist step status by ID
 */
export const updateChecklistStepStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklistStepStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateChecklistStepStatusResponses,
    UpdateChecklistStepStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistId}/{stepId}/{status}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Checklist by Checklist ID and User IDs
 */
export const getChecklistByUserIds = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklistByUserIdsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetChecklistByUserIdsResponses,
    GetChecklistByUserIdsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{checklistid}/status',
    ...options,
  });
};

/**
 * Update a checklist
 */
export const duplicateChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DuplicateChecklist1Responses,
    DuplicateChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{duplicatedId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete checklist by ID
 */
export const deleteChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteChecklist1Responses,
    DeleteChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{id}',
    ...options,
  });
};

/**
 * Get checklist by ID
 */
export const getChecklist1 = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklist1Data, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetChecklist1Responses,
    GetChecklist1Errors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklist/{id}',
    ...options,
  });
};

/**
 * Get checklist status report for team members
 */
export const getTeamMembersStatusReport = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTeamMembersStatusReportData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamMembersStatusReportResponses,
    GetTeamMembersStatusReportErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/checklists/statusreport',
    ...options,
  });
};

/**
 * Get Training Checklists based upon Request
 */
export const getFilteredPlans = <ThrowOnError extends boolean = false>(
  options: Options<GetFilteredPlansData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    GetFilteredPlansResponses,
    GetFilteredPlansErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/filteredPlans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets a list of custom quizzes
 */
export const getCustomQuizzes = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomQuizzesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCustomQuizzesResponses,
    GetCustomQuizzesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/quiz',
    ...options,
  });
};

/**
 * Create a custom quiz
 */
export const createCustomQuiz = <ThrowOnError extends boolean = false>(
  options: Options<CreateCustomQuizData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateCustomQuizResponses,
    CreateCustomQuizErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/quiz',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuiz = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCustomQuizData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateCustomQuizResponses,
    UpdateCustomQuizErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/quiz',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuiz = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCustomQuizData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteCustomQuizResponses,
    DeleteCustomQuizErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/quiz/{customQuizId}',
    ...options,
  });
};

/**
 * Get custom quiz details
 */
export const getCustomQuizDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetCustomQuizDetailsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetCustomQuizDetailsResponses,
    GetCustomQuizDetailsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/training/quiz/{customQuizId}',
    ...options,
  });
};

/**
 * Get users by locations
 */
export const listUsers = <ThrowOnError extends boolean = false>(
  options?: Options<ListUsersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListUsersResponses,
    ListUsersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/users/list',
    ...options,
  });
};

/**
 * Get operators and locations
 */
export const listOperators = <ThrowOnError extends boolean = false>(
  options?: Options<ListOperatorsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListOperatorsResponses,
    ListOperatorsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/users/operators',
    ...options,
  });
};

/**
 * Retrieve user preferences
 */
export const retrieveUserPreferences = <ThrowOnError extends boolean = false>(
  options?: Options<RetrieveUserPreferencesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    RetrieveUserPreferencesResponses,
    RetrieveUserPreferencesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/users/preferences',
    ...options,
  });
};

/**
 * Save user preferences
 */
export const saveUserPreferences = <ThrowOnError extends boolean = false>(
  options: Options<SaveUserPreferencesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveUserPreferencesResponses,
    SaveUserPreferencesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/users/preferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create a checklist
 */
export const saveChecklist = <ThrowOnError extends boolean = false>(
  options: Options<SaveChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SaveChecklistResponses,
    SaveChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update a checklist
 */
export const updateChecklist = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateChecklistResponses,
    UpdateChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all training plans
 */
export const listAllChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAllChecklistsResponses,
    ListAllChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/all',
    ...options,
  });
};

/**
 * List all training plans the active user can assign users to, as well as their assigned counts
 */
export const listAssignableChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListAssignableChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListAssignableChecklistsResponses,
    ListAssignableChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/assignable',
    ...options,
  });
};

/**
 * Status of all assigned users to this training checklist
 */
export const listAssignedByChecklist = <ThrowOnError extends boolean = false>(
  options: Options<ListAssignedByChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListAssignedByChecklistResponses,
    ListAssignedByChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/assigned/{checklistId}',
    ...options,
  });
};

/**
 * List all training checklists the active user can edit/modify
 */
export const listEditableChecklists = <ThrowOnError extends boolean = false>(
  options?: Options<ListEditableChecklistsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListEditableChecklistsResponses,
    ListEditableChecklistsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/editable',
    ...options,
  });
};

/**
 * Reset current state of Checklist for a user
 */
export const resetAllChecklistStepsState = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResetAllChecklistStepsStateData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ResetAllChecklistStepsStateResponses,
    ResetAllChecklistStepsStateErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get plan templates
 */
export const getTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<GetTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTemplatesResponses,
    GetTemplatesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/templates',
    ...options,
  });
};

/**
 * Create a plan from a template
 */
export const createChecklistFromTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateChecklistFromTemplateData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateChecklistFromTemplateResponses,
    CreateChecklistFromTemplateErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/templates/{duplicatedId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete checklist by ID
 */
export const deleteChecklist = <ThrowOnError extends boolean = false>(
  options: Options<DeleteChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteChecklistResponses,
    DeleteChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}',
    ...options,
  });
};

/**
 * Get checklist by ID
 */
export const getChecklist = <ThrowOnError extends boolean = false>(
  options: Options<GetChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetChecklistResponses,
    GetChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}',
    ...options,
  });
};

/**
 * Unassign one or more Team members to a Checklist
 */
export const unassignUsersToChecklist = <ThrowOnError extends boolean = false>(
  options: Options<UnassignUsersToChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    UnassignUsersToChecklistResponses,
    UnassignUsersToChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklist = <ThrowOnError extends boolean = false>(
  options: Options<AssignUsersToChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AssignUsersToChecklistResponses,
    AssignUsersToChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 */
export const setDueDateOnChecklist = <ThrowOnError extends boolean = false>(
  options: Options<SetDueDateOnChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SetDueDateOnChecklistResponses,
    SetDueDateOnChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/dueDate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set checklist status by ID
 */
export const updateChecklistStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateChecklistStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateChecklistStatusResponses,
    UpdateChecklistStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 *  Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism.
 */
export const stepHeartbeat = <ThrowOnError extends boolean = false>(
  options: Options<StepHeartbeatData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    StepHeartbeatResponses,
    StepHeartbeatErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/steps/{stepId}/heartbeat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update a checklist step status for a user or trainer.
 */
export const updateStepStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStepStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UpdateStepStatusResponses,
    UpdateStepStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{checklistId}/steps/{stepId}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Duplicate a plan
 */
export const duplicateChecklist = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateChecklistData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    DuplicateChecklistResponses,
    DuplicateChecklistErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v2/checklist/{duplicatedId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Handle LearnUpon webhook v2 event
 */
export const learnUponWebhookV2 = <ThrowOnError extends boolean = false>(
  options: Options<LearnUponWebhookV2Data, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    LearnUponWebhookV2Responses,
    LearnUponWebhookV2Errors,
    ThrowOnError
  >({
    url: '/webhook/learnupon/v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Handle webhook quiz event
 */
export const typeformQuiz = <ThrowOnError extends boolean = false>(
  options: Options<TypeformQuizData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    TypeformQuizResponses,
    TypeformQuizErrors,
    ThrowOnError
  >({
    url: '/webhook/quiz',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};
